import * as actionTypes from './actionTypes';

export default preferredLang => ({
  type: actionTypes.PREFERRED_LANG_CHANGED,
  preferredLang
});



// WEBPACK FOOTER //
// ./app/javascript/app/store/actions/localize.js